import React from 'react'
import { sessionStore } from '../reducers'

export default class Authenticated extends React.Component {
  render() {
    const isLoggedIn = sessionStore.getState().loggedIn
    let body = null
    if (!isLoggedIn) {
      body = this.props.children
    }
    else
    {
      body = <div>{body}</div>
    }
    return body
  }
}



// WEBPACK FOOTER //
// ./src/components/NotAuthenticated.js